import React, {useEffect, useState} from 'react';
import ResizableBox from "../../utils/ResizableBox";
import {Bar} from "react-chartjs-2";
import axios from "axios";
import {BASE_NAME} from "../../../../../services/utils/ApiUrls";
import moment from "moment";
import {getConfig} from "../../../../../services/utils/ConfigUtils";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {Backdrop, Card, CardContent, CardHeader, CircularProgress, Typography} from "@mui/material";
import clsx from "clsx";

const options = {
	responsive: true,
	plugins: {
		legend: {
			position: 'top',
		},
		title: {
			display: true,
			text: 'Numero di ticket per giorno',
		},
	},
};

export const TicketGiorno = () => {
	const classes = BaseStyle();
	const [dataGrafico, setDataGrafico] = useState(new Date());
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({
		labels: ['01/12/2021'],
		datasets: [
			{
				label: 'Mokup',
				data: [0],
				backgroundColor: 'rgb(54,161,234)',
				borderColor: 'rgb(255,17,69)',
				fill: true,
				tension: 0.5
			},
		],
	})
	
	useEffect(() => {
		setDataGrafico(new Date())
	}, [])
	
	useEffect(() => {
		setLoading(true);
		axios
			.get(BASE_NAME + "ticket/getStatsByDate/" + moment(dataGrafico).format("DD-MM-YYYY"), getConfig())
			.then((response) => {
				let newData1 = {
					labels: response.data.map(item => moment(new Date(item.label)).format("DD/MM/YYYY")),
					datasets: [
						{
							label: 'Totale giorno',
							data: response.data.map(elem => elem.data["Totale distinti"].sum),
							backgroundColor: 'rgb(54,161,234)',
							stack: 'Stack 0',
							pointRadius: 4,
							pointHoverRadius: 10,
							tension: 0.5
						},
					]
				}
				
				setData(newData1);
				setLoading(false)
				console.log(response.data)
			})
			.catch((error) => {
				setLoading(false);
				console.log(JSON.stringify(error))
			})
	}, [dataGrafico])
	
	return (
		<React.Fragment>
			<Backdrop open={loading} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>
			
			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Ticket giorno</b></Typography>}
					subheader={"Numero di ticket (asse y) per giorno (asse x)"}
				/>
				<CardContent style={{flexGrow: 1, overflow: "scroll"}}>
					
					<ResizableBox width={1200} height={600}>
						<Bar options={options} data={data} type={"bar"}/>
					</ResizableBox>
				
				</CardContent>
			</Card>
		</React.Fragment>
	);
};
